// SimpleRoutes.jsx - Simple mode route management page
// Simple, one-click operations for route management

import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useWorldState } from "../components/state/WorldStateContext.jsx";
import RoutesPanel from "../components/simple/RoutesPanel.jsx";
import NewRouteModal from "../components/simple/NewRouteModal.jsx";
import { Button } from "@/components/ui/button";
import { debug } from '../lib/debug.js';
// Icons removed - text-only UI

export default function SimpleRoutesPage() {
  const navigate = useNavigate();
  const { worldState } = useWorldState();
  const [showNewRouteModal, setShowNewRouteModal] = useState(false);

  // Handle tracking a flight on the map
  const handleTrackFlight = useCallback((flight) => {
    // Navigate to WorldMap with the flight to track
    navigate("/worldmap", { state: { trackFlightId: flight.id } });
  }, [navigate]);

  // Handle new route creation
  const handleNewRoute = useCallback(() => {
    setShowNewRouteModal(true);
  }, []);

  const handleRouteCreated = useCallback((route) => {
    debug("[SimpleRoutes] Route created:", route);
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#000" }}>
      {/* Header */}
      <div
        className="sticky top-0 z-40 flex items-center justify-between p-4"
        style={{ backgroundColor: "#0a0a0a", borderBottom: "1px solid #1a1a1a" }}
      >
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/opscenter")}
            style={{ color: "#a1a1a1" }}
          >
            &lt; Back
          </Button>
          <h1 className="text-xl font-bold" style={{ color: "#fff" }}>
            Routes
          </h1>
        </div>

        <div className="flex items-center gap-4">
          {/* Quick stats */}
          <div className="text-sm" style={{ color: "#737373" }}>
            <span style={{ color: "#22c55e" }}>{worldState?.routes?.length || 0}</span> routes
            <span className="mx-2">|</span>
            <span style={{ color: "#3b82f6" }}>{worldState?.aircraft?.length || 0}</span> aircraft
          </div>

          {/* Map button */}
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate("/worldmap")}
            style={{ borderColor: "#525252", color: "#a1a1a1" }}
          >
            View Map
          </Button>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-4xl mx-auto p-6">
        <RoutesPanel
          onNewRoute={handleNewRoute}
          onTrackFlight={handleTrackFlight}
        />
      </div>

      {/* New Route Modal */}
      <NewRouteModal
        isOpen={showNewRouteModal}
        onClose={() => setShowNewRouteModal(false)}
        onCreateRoute={handleRouteCreated}
      />
    </div>
  );
}
